import { useEffect } from "react";

export const useEvent = (event, handler, passive = false) => {
    useEffect(() => {
        window.addEventListener(event, handler, passive);
        return function cleanup() {
            window.removeEventListener(event, handler);
        };
    });
};

export const getColors = (num, gameStyle) => {
    if(gameStyle==='Classic') {
        switch (num) {
            case 2:
                return "#EBDCD0";
            case 4:
                return "#E9DBBA";
            case 8:
                return "#E9A067";
            case 16:
                return "#F08151";
            case 32:
                return "#F2654F";
            case 64:
                return "#F1462C";
            case 128:
                return "#E7C65E";
            case 256:
                return "#E8C350";
            case 512:
                return "#E8BE40";
            case 1024:
                return "#E8BB31";
            case 2048:
                return "#E7B723";
            default:
                return "#C2B3A3";
        }
    } else {
        switch (num) {
            case 2:
                return "#BBC1C6";
            case 4:
                return "#968EAF";
            case 8:
                return "#6D5593";
            case 16:
                return "#543D7B";
            case 32:
                return "#FD9C09";
            case 64:
                return "#292651";
            case 128:
                return "#200D3A";
            case 256:
                return "#588B7E";
            case 512:
                return "#96A385";
            case 1024:
                return "#D0AC7F";
            case 2048:
                return "#C47A5A";
            default:
                return "#77f";
        }
    }

};